import jQuery from 'jquery'
window.$ = jQuery
window.jQuery = jQuery

    jQuery(document).ready(function(){

        var $element = $('.topbar'),
            className = 'scrolled';

        jQuery(document).scroll(function() {
            if (jQuery(document).scrollTop() >= 50) {
                $element.addClass(className);
            } else {
                $element.removeClass(className);
            }
        });

        jQuery('.hamburger').on('click', function () {
            jQuery('.hamburgermenu').toggleClass('slided');
            jQuery('.wrapper').toggleClass('slideleft');
            jQuery('.trigger').toggleClass('crossed');
            jQuery('body').toggleClass('noscroll');
        });

        /* GET ACTIVE CLASS FOR MENUES */
        var bodyclass = jQuery('body');

        if (bodyclass.hasClass('task1')) {
            jQuery('.numbered:nth-child(2)').addClass('active');
        }
        if (bodyclass.hasClass('task2')) {
            jQuery('.numbered:nth-child(2)').addClass('done');
            jQuery('.numbered:nth-child(3)').addClass('active');
        }
    });


    jQuery.fn.select2Buttons = function(options) {
        return this.each(function(){
            var $ = jQuery;
            var select = $(this);
            var multiselect = select.attr('multiple');
            select.hide();

            var buttonsHtml = $('<div class="select2Buttons"></div>');
            var selectIndex = 0;
            var addOptGroup = function(optGroup){
                if (optGroup.attr('label')){
                    buttonsHtml.append('<strong>' + optGroup.attr('label') + '</strong>');
                }
                var ulHtml =  $('<ul class="select-buttons">');
                optGroup.children('option').each(function(){
                    var liHtml = $('<li></li>');
                    if ($(this).attr('disabled') || select.attr('disabled')){
                        liHtml.addClass('disabled');
                        liHtml.append('<span>' + $(this).html() + '</span>');
                    }else{
                        liHtml.append('<a href="#" data-select-index="' + selectIndex + '">' + $(this).html() + '</a>');
                    }

                    // Mark current selection as "picked"
                    if((!options || !options.noDefault) && $(this).attr('selected')){
                        liHtml.children('a, span').addClass('picked');
                    }
                    ulHtml.append(liHtml);
                    selectIndex++;
                });
                buttonsHtml.append(ulHtml);
            }

            var optGroups = select.children('optgroup');
            if (optGroups.length == 0) {
                addOptGroup(select);
            }else{
                optGroups.each(function(){
                    addOptGroup($(this));
                });
            }

            select.after(buttonsHtml);

            buttonsHtml.find('a').click(function(e){
                e.preventDefault();
                var clickedOption = $(select.find('option')[$(this).attr('data-select-index')]);
                if(multiselect){
                    if(clickedOption.attr('selected')){
                        $(this).removeClass('picked');
                        clickedOption.removeAttr('selected');
                    }else{
                        $(this).addClass('picked');
                        clickedOption.attr('selected', 'selected');
                    }
                }else{
                    buttonsHtml.find('a, span').removeClass('picked');
                    $(this).addClass('picked');
                    clickedOption.attr('selected', 'selected');
                }
                select.trigger('change');
            });
        });
    };









// WEBPACK FOOTER //
// ./src/assets/js/custom.js